module.exports = __webpack_public_path__ + "img/promotional.4216b1af.png";